import React from 'react';
import divider1 from "../assets/images/Polygon 1.svg";
import divider2 from "../assets/images/Star 1.svg";
import divider3 from "../assets/images/half_circle.svg";
import divider4 from "../assets/images/Union.svg";
import divider5 from "../assets/images/Rectangle 1.svg";

function InfoBar() {
  return (
    <div className="info-bar">
      <div className="container">
        <div className="info-bar-inner">
        <img src={divider1} alt="divider icon" className="info-bar-divider-icon" />
          <span className="info-bar-item">
            {/* <i className="ri-organization-chart" aria-hidden="true" /> */}
            IASG
          </span>
          <img src={divider2} alt="divider icon" className="info-bar-divider-icon" />
          <span className="info-bar-item">
            {/* <i className="ri-star-line" aria-hidden="true" /> */}
            Mid-Term Conference 2026
          </span>
          <img src={divider3} alt="divider icon" className="info-bar-divider-icon" />
          {/* <i className="ri-arrow-right-s-line info-bar-divider" aria-hidden="true" /> */}
          <span className="info-bar-item">
            {/* <i className="ri-calendar-line" aria-hidden="true" /> */}
            28–29 March 2026
          </span>
          <img src={divider4} alt="divider icon" className="info-bar-divider-icon" />
          <span className="info-bar-item">
            {/* <i className="ri-map-pin-line" aria-hidden="true" /> */}
            Patna
          </span>
          <img src={divider5} alt="divider icon" className="info-bar-divider-icon" />
          {/* <i className="ri-snowflake-line info-bar-icon-end" aria-hidden="true" /> */}
        </div>
      </div>
    </div>
  );
}

export default InfoBar;
